import { takeLeading, fork, put } from 'redux-saga/effects'
import i18n from 'i18next'

import { ErrorResponse } from '~api/models'
import { isDebugEnv } from '~config/envConfig'

import { BootstrapData } from './reducer'
import {
  initApp,
  addToastToBeDisplayed,
} from './actions'

export function* globalSagas() {
  yield fork(watchInitApp)
}

/**
 * init App
 */
function* watchInitApp() {
  yield takeLeading(initApp.started, function* () {
    try {
      // add calls or store initializations which should run on app initialization here
      const bootstrapData: BootstrapData = {}
      yield put(initApp.done({ result: bootstrapData }))
    } catch (e) {
      yield displayAPIError(e, 'watchInitApp')
      yield put(initApp.failed({ error: e }))
    }
  })
}

/**
 * helper functions
 */
export function* displayAPIError(errorResponse: Response & {message: string, stack: string}, functionName: string, persist?: boolean) {
  const unknownError = i18n.t('error:unknownErrorHasOccurred')
  let errorMessage = unknownError

  if (isDebugEnv) console.log(`error in saga: ${functionName}`, errorResponse)

  if (errorResponse.status) {
    const json: ErrorResponse = yield errorResponse.json()

    return yield put(addToastToBeDisplayed({
      severity: 'error',
      content: typeof json.message === 'string' ? json.message : unknownError,
      persist: persist || true,
    }))
  } else if (errorResponse.message) {
    // if the request failed because there was not internet then there will only be a message but not status
    errorMessage = errorResponse.message
  }

  switch (errorResponse.message) {
    case 'Failed to fetch': errorMessage = i18n.t('error:fetchUserError'); break
  }

  return yield put(addToastToBeDisplayed({
    persist,
    severity: 'error',
    content: errorMessage,
  }))
}
